import './comp_marksheet_two.css'

const Comp_Markseet_Two=(props)=>{
    return(
    
    <div class="form-container-tabble2">
        <div class="form-title">
            Mid Term Assessment (oral questions to assess knowledge and understanding gained by the cadet)
        </div>
        <table class="sectionn1">
            <tr>
                <td>-</td>
            </tr>
            <tr>
                <td>-</td>
            </tr>
            <tr>
                <td>-</td>
            </tr>
        </table>

        <div class="form-title">
            Corrective actions to be taken for improving CRB task made at the time of Mid Term
            Assessment:
        </div>
        <table class="sectionn1">
            <tr>
                <td>Sr.</td>
                <td>Remarks</td>
            </tr>
            <tr>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td></td>
                <td></td>
            </tr>
        </table>

        <div class="form-title">
            Corrective actions to be taken for improving project work made at the time of Mid Term
            Assessment: 
        </div>
        <table class="sectionn1">
            <tr>
                <td>Sr.</td>
                <td>Remarks</td>
            </tr>
            <tr>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td></td>
                <td></td>
            </tr>
        </table>

        <div class="form-title">
            Corrective actions to be taken for improving Activity book made at the time of Mid Term
            Assessment:  
        </div>
        <table class="sectionn1">
            <tr>
                <td>Sr.</td>
                <td>Remarks</td>
            </tr>
            <tr>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td></td>
                <td></td>
            </tr>
        </table>

        <table class="text-table">
            <td colspan="2">Received the above report and agreed on the shortcomings and recommendations</td>
            <tr>
                <td>Cadet:</td>
                <td></td>
            </tr>
            <tr>
                <td>Date:</td>
                <td></td>
            </tr>
        </table>

        <div class="signature-section">
            <div class="signature-block">
                STP OFFICER NAME AND SIGNATURE
            </div>
            <div class="signature-block">
                PRE-SEA INSTITUTE STAMP
            </div>
        </div>
        </div>
    )
}

export default Comp_Markseet_Two;